import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/dataLake/importer/dataLakeImporterActions';

export default importerReducers(actions);
